<label
  (click)="onClose.emit()"
  for="{{ uploadIdPrefix }}asset-upload"
  appButton
  name="source-device"
  location="assets-section"
  [hasIcon]="true"
  color="simple"
  class="align-left"
  spacing="1-5"
  height="1"
>
  <app-svg src="/assets/icons/upload.svg"></app-svg>
  <span>Device</span></label
>
<div class="divider"></div>

<button
  (click)="openDropboxDialog(); onClose.emit()"
  appButton
  name="dropbox"
  location="assets-section"
  [hasIcon]="true"
  color="simple"
  class="align-left"
  spacing="1-5"
  height="1"
>
  <img src="/assets/icons/logo/dropbox-color.svg" alt="dropbox" />
  <span>Dropbox</span>
  <app-upgrade-badge [scope]="'gallery:other-source-upload'" location="upload-source-menu"></app-upgrade-badge>
</button>

<!-- <button
  (click)="openGoogleDriveDialog(); onClose.emit()"
  appButton
  name="google-drive"
  location="assets-section"
  [hasIcon]="true"
  color="simple"
  class="align-left"
  spacing="1-5"
  height="1"
>
  <img src="/assets/icons/logo/drive-color.svg" alt="dropbox" />
  <span>Google Drive</span>
  <app-upgrade-badge [scope]="'gallery:other-source-upload'" location="upload-source-menu"></app-upgrade-badge>
</button> -->

<button
  (click)="openBoxDialog(); onClose.emit()"
  appButton
  name="box"
  location="assets-section"
  [hasIcon]="true"
  color="simple"
  class="align-left"
  spacing="1-5"
  height="1"
>
  <img src="/assets/icons/logo/box-color.svg" alt="dropbox" />
  <span>Box</span>
  <app-upgrade-badge [scope]="'gallery:other-source-upload'" location="upload-source-menu"></app-upgrade-badge>
</button>

@if (growthBook.isOn('ai_generation')) {
  <div class="divider"></div>
  <button
    (click)="openAiDialog(); onClose.emit()"
    appButton
    name="ai"
    location="assets-section"
    [hasIcon]="true"
    color="simple"
    class="align-left"
    spacing="1-5"
    height="1"
  >
    <app-svg src="/assets/icons/image-spark.svg" color="primary"></app-svg>
    <span>Image Generator</span>
    <app-badge color="orange">Beta</app-badge>
  </button>
}
